import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/asaini/infra/dsmtop_wiki/db2-dsmtop-wiki/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>Purpose</h2>
    <p>Show how much work is happening in each WLM service class.</p>
    <p>One of the main purposes of WLM service classes is to apply different priorities and or policies to different types of work.  For example, limiting the number of large queries allowed to run concurrently.  Service classes are also used to give higher priority to business critical applications.</p>
    <p>Validating that service classes are serving their intended purpose requires monitoring the performance of activities that are running in them.</p>
    <p>Each row in this view shows a service subclass.  You can use filtering or sorting to group the service subclasses by service superclass.</p>
    <undefined><p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1111px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "44.79166666666667%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAIAAAC9o5sfAAAACXBIWXMAAAsSAAALEgHS3X78AAABVklEQVQoz4WQ22rCQBCG86rtA9jWU5QUrV4YClJMinjhhRjbmHP2lGTdJOqj9Y+VUqjQn2EZZuf7Z3a1Xs996s7u7het1uvD40wfLAYDq9uf9/tvSAzjfTi0LmF3OnNdXyDRdbvdtsbjjbZapVH84XmREDQM9wguSFFwIQghURR5iCBw0yT0vU/GU87TJAkpJZTGmm0le3fn+36eF74fOA7yAFd5ngNlaE/hQillQmRZnqeNiBCCMabZdsxZolRZKuW6bhRGUkp1EUYUUnLOC2zCeV3XVVkhEY1NBj9tuaRx7IUhNqEgd7ud53uHC8wohRH6AOMsG3+VNeNzVBrYcerzGdUSrj8q/xO2wGO07bY6nRr4t27yV9/mRh2PNf7sBvz94L+wuqo8HGBUk5Rom42qKlngZyTOAt7r9do0TXRJeS2CDILg2TCm06lpjiaT3mjUNc2XL/rwa3SolleBAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Throughput-ServciceClasses.png",
            "title": "Throughput-ServciceClasses.png",
            "src": "/db2-dsmtop-wiki/static/f92d900a6f8e9a5f9d49d6346e4c300a/70b72/Throughput-ServiceClasses.png",
            "srcSet": ["/db2-dsmtop-wiki/static/f92d900a6f8e9a5f9d49d6346e4c300a/7fc1e/Throughput-ServiceClasses.png 288w", "/db2-dsmtop-wiki/static/f92d900a6f8e9a5f9d49d6346e4c300a/a5df1/Throughput-ServiceClasses.png 576w", "/db2-dsmtop-wiki/static/f92d900a6f8e9a5f9d49d6346e4c300a/70b72/Throughput-ServiceClasses.png 1111w"],
            "sizes": "(max-width: 1111px) 100vw, 1111px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span></p>
      <h2>{`Metrics Shown`}</h2>
      <p><u parentName="p">{`Service Superclass Name`}</u></p>
      <p><span parentName="p" {...{
          "style": {
            "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
          }
        }}>{`Source: `}</span><a parentName="p" {...{
          "href": "http://www-01.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.sql.rtn.doc/doc/r0053941.html?lang=en",
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`mon_get_service_subclass`}</a><span parentName="p" {...{
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`.service_superclass_name`}</span></p>
      <p><u parentName="p">{`Service Subclass Name`}</u></p>
      <p><span parentName="p" {...{
          "style": {
            "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
          }
        }}>{`Source: `}</span><a parentName="p" {...{
          "href": "http://www-01.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.sql.rtn.doc/doc/r0053941.html?lang=en",
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`mon_get_service_subclass`}</a><span parentName="p" {...{
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`.service_subclass_name`}</span></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}><u parentName="p">{`CPU Time`}</u></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}>{`Source: `}<a parentName="p" {...{
          "href": "http://www-01.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.sql.rtn.doc/doc/r0053941.html?lang=en",
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`mon_get_service_subclass`}</a><span parentName="p" {...{
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`.total_cpu_time`}</span></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}><u parentName="p">{`Activities Completed / m`}</u></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}>{`The number of activities completed per minute is one measure of how much work is being accomplished by connections associated with this service subclass.  Activities typically correspond to a query, although there a few additional things that count as an activity including LOAD and stored procedures calls.`}</p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}>{`Source: `}<a parentName="p" {...{
          "href": "http://www-01.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.sql.rtn.doc/doc/r0053941.html?lang=en",
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`mon_get_service_subclass`}</a><span parentName="p" {...{
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`.act_completed_total`}</span></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}><u parentName="p">{`Activities Aborted / m`}</u></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}>{`Source: `}<a parentName="p" {...{
          "href": "http://www-01.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.sql.rtn.doc/doc/r0053941.html?lang=en",
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`mon_get_service_subclass`}</a><span parentName="p" {...{
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`.act_aborted_total`}</span></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}><u parentName="p">{`Activities Rejected / m`}</u></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}>{`Source: `}<a parentName="p" {...{
          "href": "http://www-01.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.sql.rtn.doc/doc/r0053941.html?lang=en",
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`mon_get_service_subclass`}</a><span parentName="p" {...{
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`.act_rejected_total`}</span></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}><u parentName="p">{`App Rqsts Completed / m`}</u></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}>{`Source: `}<a parentName="p" {...{
          "href": "http://www-01.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.sql.rtn.doc/doc/r0053941.html?lang=en",
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`mon_get_service_subclass`}</a><span parentName="p" {...{
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`.app_rqsts_completed_total`}</span></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}><u parentName="p">{`Avg App Rqst Time (ms)`}</u></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}><u parentName="p">{`Activities Queued / m`}</u></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}>{`Source: `}<a parentName="p" {...{
          "href": "http://www-01.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.sql.rtn.doc/doc/r0053941.html?lang=en",
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`mon_get_service_subclass`}</a><span parentName="p" {...{
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`.wlm_queue_assignments_total`}</span></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}><u parentName="p">{`Rows Read / m`}</u></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}>{`Source: `}<a parentName="p" {...{
          "href": "http://www-01.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.sql.rtn.doc/doc/r0053941.html?lang=en",
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`mon_get_service_subclass`}</a><span parentName="p" {...{
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`.rows_read`}</span></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}><u parentName="p">{`Rows Modified / m`}</u></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}>{`Source: `}<a parentName="p" {...{
          "href": "http://www-01.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.sql.rtn.doc/doc/r0053941.html?lang=en",
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`mon_get_service_subclass`}</a><span parentName="p" {...{
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`.rows_modified`}</span></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}><u parentName="p">{`Rows Returned / m`}</u></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}>{`Source: `}<a parentName="p" {...{
          "href": "http://www-01.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.sql.rtn.doc/doc/r0053941.html?lang=en",
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`mon_get_service_subclass`}</a><span parentName="p" {...{
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`.rows_returned`}</span></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}><u parentName="p">{`Logical Reads / m`}</u></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}>{`Source: `}<a parentName="p" {...{
          "href": "http://www-01.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.sql.rtn.doc/doc/r0053941.html?lang=en",
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`mon_get_service_subclass`}</a></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif",
          "marginLeft": "40px"
        }
      }}>{` `}</p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "marginLeft": "40px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}><a parentName="p" {...{
          "href": "http://www-01.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.admin.mon.doc/doc/r0001235.html?cp=SSEPGG_10.5.0&lang=en",
          "style": {
            "textDecoration": "underline",
            "color": "rgb( 5 , 56 , 107 )",
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`pool_data_l_reads`}</a><span parentName="p" {...{
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{` + `}</span><a parentName="p" {...{
          "href": "http://www-01.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.admin.mon.doc/doc/r0001238.html?lang=en",
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`pool_index_l_reads`}</a><span parentName="p" {...{
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{` + `}</span><a parentName="p" {...{
          "href": "http://www-01.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.admin.mon.doc/doc/r0022731.html?lang=en",
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`pool_xda_l_reads`}</a><span parentName="p" {...{
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{` + `}<a parentName="span" {...{
            "href": "http://www.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.admin.mon.doc/doc/r0060763.html?lang=en"
          }}>{`pool_col_l_reads`}</a>{` +`}</span></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "marginLeft": "40px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}><a parentName="p" {...{
          "href": "http://www.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.admin.mon.doc/doc/r0011302.html?lang=en"
        }}>{`pool_temp_data_l_reads `}</a><span parentName="p" {...{
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace",
            "lineHeight": "1.5"
          }
        }}>{`+ `}<a parentName="span" {...{
            "href": "http://www.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.admin.mon.doc/doc/r0011303.html?cp=SSEPGG_10.5.0&lang=en"
          }}>{`pool_temp_index_l_reads `}</a>{`+ `}<a parentName="span" {...{
            "href": "http://www.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.admin.mon.doc/doc/r0022738.html?cp=SSEPGG_10.5.0&lang=en"
          }}>{`pool_temp_xda_l_reads `}</a>{`+ `}<a parentName="span" {...{
            "href": "http://www.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.admin.mon.doc/doc/r0060873.html?cp=SSEPGG_10.5.0&lang=en"
          }}>{`pool_temp_col_l_reads`}</a></span></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}><u parentName="p">{`Direct Reads / m`}</u></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}>{`Source: `}<a parentName="p" {...{
          "href": "http://www-01.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.sql.rtn.doc/doc/r0053941.html?lang=en",
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`mon_get_service_subclass`}</a><span parentName="p" {...{
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`.direct_reads`}</span></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}><u parentName="p">{`Direct Writes / m`}</u></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}>{`Source: `}<a parentName="p" {...{
          "href": "http://www-01.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.sql.rtn.doc/doc/r0053941.html?lang=en",
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`mon_get_service_subclass`}</a><span parentName="p" {...{
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`.direct_writes`}</span></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}><u parentName="p">{`Lock Waits / m`}</u></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}>{`Source: `}<a parentName="p" {...{
          "href": "http://www-01.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.sql.rtn.doc/doc/r0053941.html?lang=en",
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`mon_get_service_subclass`}</a><span parentName="p" {...{
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`.lock_waits`}</span></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}><u parentName="p">{`Lock Timeouts / m`}</u></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}>{`Source: `}<a parentName="p" {...{
          "href": "http://www-01.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.sql.rtn.doc/doc/r0053941.html?lang=en",
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`mon_get_service_subclass`}</a><span parentName="p" {...{
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`.lock_timeouts`}</span></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}><u parentName="p">{`Lock Escal / m`}</u></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}>{`Source: `}<a parentName="p" {...{
          "href": "http://www-01.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.sql.rtn.doc/doc/r0053941.html?lang=en",
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`mon_get_service_subclass`}</a><span parentName="p" {...{
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`.lock_escals`}</span></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}><u parentName="p">{`Deadlocks / m`}</u></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}>{`Source: `}<a parentName="p" {...{
          "href": "http://www-01.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.sql.rtn.doc/doc/r0053941.html?lang=en",
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`mon_get_service_subclass`}</a><span parentName="p" {...{
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`.deadlocks`}</span></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}><u parentName="p">{`Threshold Violations / m`}</u></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}>{`Source: `}<a parentName="p" {...{
          "href": "http://www-01.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.sql.rtn.doc/doc/r0053941.html?lang=en",
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`mon_get_service_subclass`}</a><span parentName="p" {...{
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`.thresh_violations`}</span></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}><u parentName="p">{`Sorts / m`}</u></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}>{`Source: `}<a parentName="p" {...{
          "href": "http://www-01.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.sql.rtn.doc/doc/r0053941.html?lang=en",
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`mon_get_service_subclass`}</a><span parentName="p" {...{
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`.total_sorts`}</span></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}><u parentName="p">{`Sort Overflows / m`}</u></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}>{`Source: `}<a parentName="p" {...{
          "href": "http://www-01.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.sql.rtn.doc/doc/r0053941.html?lang=en",
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`mon_get_service_subclass`}</a><span parentName="p" {...{
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`.sort_overflows`}</span></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}><u parentName="p">{`Hash Group By Ops / m`}</u></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}>{`Source: `}<a parentName="p" {...{
          "href": "http://www-01.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.sql.rtn.doc/doc/r0053941.html?lang=en",
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`mon_get_service_subclass`}</a><span parentName="p" {...{
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`.total_hash_grpbys`}</span></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}><u parentName="p">{`Hash Group By Overflows / m`}</u></p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}>{`Source: `}<a parentName="p" {...{
          "href": "http://www-01.ibm.com/support/knowledgecenter/SSEPGG_10.5.0/com.ibm.db2.luw.sql.rtn.doc/doc/r0053941.html?lang=en",
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`mon_get_service_subclass`}</a><span parentName="p" {...{
          "style": {
            "fontFamily": "'courier new' , 'courier' , monospace"
          }
        }}>{`.hash_grpby_overflows`}</span></p>
      <h2 {...{
        "style": {
          "fontSize": "1.5em",
          "textShadow": "rgb( 255 , 255 , 255 ) 0px 1px 0px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif",
          "color": "rgb( 0 , 0 , 0 ) !important",
          "padding": "2px !important",
          "border": "none !important"
        }
      }}>{`Default Sort Column`}</h2>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}>{`CPU Time, descending`}</p>
      <h2 {...{
        "style": {
          "fontSize": "1.5em",
          "textShadow": "rgb( 255 , 255 , 255 ) 0px 1px 0px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif",
          "color": "rgb( 0 , 0 , 0 ) !important",
          "padding": "2px !important",
          "border": "none !important"
        }
      }}>{`Navigation`}</h2>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}>{`Keyboard navigation: Vts`}</p>
      <p {...{
        "style": {
          "marginBottom": "5px",
          "paddingTop": "2px",
          "paddingBottom": "2px",
          "fontFamily": "'helvetica neue' , 'helvetica' , 'arial' , sans-serif"
        }
      }}>{`Dedicated shortcut key: (none)`}</p>
      <h6>{`Author: KevinLBeck`}</h6></undefined>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      